module.exports = __webpack_public_path__ + "static/img/infoImg.8a789ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/infoImg.png
// module id = D2OJ
// module chunks = 2